import axios from 'axios';

 
//const setAuthToken = token => {
export default function setAuthToken(token) {    
    if (token) {
        //delete axios.defaults.headers.common["Authorization"];
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    else
        delete axios.defaults.headers.common["Authorization"];
    /*
       axios.interceptors.request.use(
        config => {
          config.headers['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
              return config;
          },
          error => {
              return Promise.reject(error);
          }
      );
      */
}

